import React from 'react';
import PropTypes from 'prop-types';
import makeRequest from 'utils/makeRequest';
import InViewObserver from 'components/InViewObserver/InViewObserver';
import Link from 'components/Link';
import analyticsWrapper from '../../../helpers/analytics/analyticsWrapper';
import s from './LinksList.scss';

class LinksList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      linksData: undefined,
      cardFiltersData: undefined,
      defaultCardFilter: undefined,
    };
  }

  loadKeywordsData = () => {
    const { sectionData, cardKeywordsFilter, dataUrl } = this.props;

    if (sectionData && sectionData.data) {
      this.setState({
        linksData: this.props.sectionData.data,
      });
      return;
    }
    if (cardKeywordsFilter && dataUrl) {
      makeRequest
        .get(dataUrl)
        .then(response => {
          if (
            response &&
            response.status === 200 &&
            response.data &&
            response.data.content_json &&
            response.data.content_json.groups &&
            Array.isArray(response.data.content_json.groups)
          ) {
            this.setState(
              {
                cardFiltersData: response.data.content_json.groups,
                defaultCardFilter: response.data.content_json.default,
              },
              this.filterCardKeywords,
            );
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  };

  filterCardKeywords = () => {
    const { cardFiltersData, defaultCardFilter } = this.state;
    const { cardKeywordsFilter } = this.props;
    if (!cardFiltersData || !Array.isArray(cardFiltersData)) {
      return;
    }
    try {
      let filteredKeywordData;
      if (cardKeywordsFilter && typeof cardKeywordsFilter === 'string') {
        filteredKeywordData = cardFiltersData.filter(
          filter =>
            filter.name &&
            filter.name.toLowerCase() === cardKeywordsFilter.toLowerCase(),
        );
      }
      if (
        (!filteredKeywordData || !filteredKeywordData.length) &&
        defaultCardFilter
      ) {
        filteredKeywordData = cardFiltersData.filter(
          filter => filter.name && filter.name === defaultCardFilter,
        );
      }
      if (
        filteredKeywordData &&
        filteredKeywordData.length > 0 &&
        filteredKeywordData[0].links &&
        Array.isArray(filteredKeywordData[0].links)
      ) {
        this.setState({
          linksData: filteredKeywordData[0].links.map(keyword => ({
            hl: keyword.label,
            wu: keyword.url,
          })),
        });
      } else {
        this.setState({
          linksData: undefined,
        });
      }
    } catch (e) {
      // console.loog(e);
    }
  };

  componentDidUpdate(prevProps, prevState) {
    const { cardFiltersData } = this.state;
    const { cardKeywordsFilter } = this.props;

    if (
      ((prevState.cardFiltersData || cardFiltersData) &&
        prevState.cardFiltersData !== cardFiltersData) ||
      (cardFiltersData &&
        Array.isArray(cardFiltersData) &&
        cardKeywordsFilter &&
        prevProps.cardKeywordsFilter !== cardKeywordsFilter)
    ) {
      this.filterCardKeywords();
    }
  }

  componentRender = () => {
    const {
      gaCategory,
      gaAction,
      gaLabel,
      heading,
      cssSelector,
      sectionData,
      isEtimes,
      ga4Type,
    } = this.props;
    const { linksData } = this.state;
    const cssSelectorClass = s[cssSelector];

    const items =
      (sectionData && (sectionData.data || sectionData.items)) || linksData;
    const ga4category = sectionData && sectionData.ga4Category;

    return items && Array.isArray(items) ? (
      <InViewObserver
        inViewCallback={() => {
          if (ga4category) {
            analyticsWrapper('ga4', {
              event: 'user_shown',
              type: `in_focus_widget`,
              category: `${ga4category}`,
            });
          }
        }}
      >
        <div className={`${s.trending} ${cssSelectorClass}`}>
          {heading ? (
            <div className={`${s.title}`}>
              <span>{heading}</span>
            </div>
          ) : null}
          <div className={`${s.trending_list}`}>
            <ul>
              {items.map((item, index) => {
                const itemHeading =
                  item &&
                  item.hl &&
                  typeof item.hl === 'string' &&
                  item.hl.split('**:').length > 0
                    ? item.hl.split('**:')[0]
                    : item.hl;
                return (
                  <li>
                    <Link
                      to={item.wu}
                      className="keyword"
                      data-ga={`${gaCategory}|${gaAction.replace(
                        '###index###',
                        index + 1,
                      )}|${
                        gaLabel && gaLabel === 'wu'
                          ? `${item.wu}`
                          : (gaLabel && `${gaLabel}${itemHeading}`) ||
                            `re_${itemHeading}${item.wu && `_${item.wu}`}`
                      }`}
                      key={index}
                      ga4Data={
                        ga4Type && isEtimes
                          ? [
                              {
                                event: 'user_click',
                                type: `${ga4Type}`,
                                label: `${itemHeading}`,
                              },
                            ]
                          : ga4category &&
                            !isEtimes && [
                              {
                                event: 'user_click',
                                type: `in_focus_widget`,
                                category: `${ga4category}`,
                                label: `${itemHeading}`,
                              },
                            ]
                      }
                    >
                      {itemHeading}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </InViewObserver>
    ) : (
      ''
    );
  };

  render() {
    const { csr } = this.props;

    return csr ? (
      <InViewObserver
        inViewCallback={() => {
          this.loadKeywordsData();
        }}
        viewMargin="400px 0px 400px 0px"
      >
        {this.componentRender()}
      </InViewObserver>
    ) : (
      this.componentRender()
    );
  }
}

LinksList.propTypes = {
  sectionData: PropTypes.shape({}),
  cssSelector: PropTypes.string,
  gaCategory: PropTypes.string,
  gaAction: PropTypes.string,
  gaLabel: PropTypes.string,
  heading: PropTypes.string,
  dataUrl: PropTypes.string,
  cardKeywordsFilter: PropTypes.string,
  csr: PropTypes.bool,
  isEtimes: PropTypes.bool,
  ga4Type: PropTypes.string,
  ga4Category: PropTypes.string,
};

LinksList.defaultProps = {
  sectionData: undefined,
  cssSelector: '',
  gaCategory: 'TrendingTopics',
  gaAction: 'Click',
  gaLabel: '',
  heading: undefined,
  dataUrl: undefined,
  cardKeywordsFilter: '',
  csr: false,
  isEtimes: false,
  ga4Type: '',
  ga4Category: '',
};
export default LinksList;
